import React, { useLayoutEffect, useRef, useState } from "react";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

/**
 * Detailpagina in twee kolommen: inhoud links, samenvatting/koppelingen rechts.
 *
 * De zijkolom draagt wat je "in één oogopslag" wilt zien (status, leverancier,
 * bedragen, gekoppelde records). Daardoor hoeft de hoofdkolom alleen nog het
 * werk te tonen — de regels en de geschiedenis. Bij te weinig ruimte klapt alles
 * onder elkaar, met de zijkolom eerst zodat de samenvatting op smalle schermen
 * bovenaan blijft staan.
 *
 * Het breekpunt meet de CONTAINER, niet de viewport. Op antd's `lg` (992px) komt
 * namelijk óók de zijbalk van 250px terug, dus precies op dat punt klapt de
 * hoofdkolom van ~941px naar ~356px — het moment waarop je twee kolommen krijgt
 * is exact het moment waarop er geen ruimte voor is. Meten op de container is
 * meteen ook bestand tegen een ingeklapte zijbalk, tegen de top-nav-variant en
 * tegen browserzoom.
 */
const DetailLayout = ({ children, aside, asideWidth = 316, mainMinWidth = 760 }) => {
  const screens = useBreakpoint();
  const ref = useRef(null);
  const [width, setWidth] = useState(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Vóór de eerste meting (en zonder ResizeObserver) terugvallen op het
  // viewport-breekpunt, zodat de eerste render niet verkeerd staat.
  const stacked = width === null ? !screens.lg : width < mainMinWidth + 20 + asideWidth;

  return (
    <div ref={ref} style={{ minWidth: 0 }}>
      {stacked ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {aside ? <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>{aside}</div> : null}
          <div style={{ display: "flex", flexDirection: "column", gap: 20, minWidth: 0 }}>{children}</div>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `minmax(0, 1fr) ${asideWidth}px`,
            gap: 20,
            alignItems: "start",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 20, minWidth: 0 }}>{children}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20, minWidth: 0 }}>{aside}</div>
        </div>
      )}
    </div>
  );
};

export default DetailLayout;
